/**
 * Procedure Categories and Procedures for MD in Geriatrics students
 * Extracted with strict evidence from official NMC PDF
 */
export const GERIATRICS_PROCEDURES = {
  "Geriatric Bedside & Wound Interventions": [
    "Pressure Ulcer Debridement & Advanced Wound Dressing",
    "Urinary Catheterization & Incontinence Management",
  ],
  "Geriatric Critical & Respiratory Care": [
    "Administration of Non-Invasive Ventilation (NIV)",
    "Oxygen Therapy & Airway Management",
  ],
};

export const GERIATRICS_CATEGORIES = Object.keys(GERIATRICS_PROCEDURES);

export const isMDInGeriatricsDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (d.includes("geriatrics") || d.includes("geriatric medicine")) && !d.includes("mental") && !d.includes("psychiatry");
};
